import * as React from "react";

import { Box, styled } from "@mui/material";
import { Typography } from "mpulse-design-system";

import mPulseLogo from "../../images/mpulse_mobile_logo_white.svg";
import ivrManagerLogo from "../../images/IVR_Manager_White.svg";
import backgroundImg from "../../images/background.svg";

import { useVersionInfo } from "../../hooks/useVersionInfo";
import VersionInfo from "../VersionInfo/VersionInfo";

const LoginContainer = ({ children }) => {
  const { showVersionInfo, setShowVersionInfo, handleVersionInfo } =
    useVersionInfo();

  return (
    <BoxWithBackground>
      <BackgroundImg src={backgroundImg} alt="Background Design" />
      <AppLogo src={ivrManagerLogo} alt={"IVR Manager Logo"} />
      <StyledBox>{children}</StyledBox>
      <Box
        onClick={handleVersionInfo}
        sx={{ marginTop: (theme) => theme.spacing(4), position: "relative" }}
      >
        <Typography
          variant="subtitle2"
          color="textWhite"
          sx={{ fontWeight: "bold", fontSize: "11px !important" }}
        >
          POWERED BY
        </Typography>
        <MPulseLogo src={mPulseLogo} alt="mPulse Logo" />
      </Box>
      <VersionInfo {...{ showVersionInfo, setShowVersionInfo }} />
    </BoxWithBackground>
  );
};

const wBreakpoints = [500, 768, 992, 1100, 1200, 1400, 1600, 1800],
  mqW = wBreakpoints.map((bp) => `@media (min-width: ${bp}px)`);

const MPulseLogo = styled("img")(() => ({
    height: "40px",
  })),
  AppLogo = styled("img")(({ theme }) => ({
    height: "56px",
    paddingBottom: theme.spacing(4),
  })),
  StyledBox = styled(Box)(() => ({
    height: "575px",
    width: "405px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  })),
  BoxWithBackground = styled(Box)(({ theme }) => ({
    position: "absolute",
    padding: `${theme.spacing(2)} 0`,
    top: 0,
    left: 0,
    minHeight: "100%",
    width: "100vw",
    background: "linear-gradient(87deg, #00A9F7, #006391)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  })),
  BackgroundImg = styled("img")`
    height: 100%;
    position: absolute;
    left: -37vw;
    z-index: 0;

    ${mqW[0]} {
      left: -37vw;
    }

    ${mqW[1]} {
      left: -37vw;
    }

    ${mqW[2]} {
      left: -37vw;
    }

    ${mqW[3]} {
      left: -42vw;
    }

    ${mqW[4]} {
      left: -37vw;
    }

    ${mqW[5]} {
      left: -30vw;
    }

    ${mqW[6]} {
      left: -23vw;
    }

    ${mqW[7]} {
      left: -12vw;
    }
  `;

export default LoginContainer;
